import { z } from "zod";

export const GOAL_DETAILS_MODALS = [
	"updateProgress",
	"archive",
	"complete",
	"delete",
	"share",
	"edit-as-of-date",
] as const;
export const ActivityStreamTabName = ["activity", "details", "progress"] as const;
const CONFIG = {
	queryParametersSchema: z.object({
		modal: z.enum(GOAL_DETAILS_MODALS).optional().catch(undefined),
		initialGoalProgressValue: z.number().optional().catch(undefined),
		editHistoryEntryId: z.string().optional().catch(undefined),
	}),
	savedQueryParametersSchema: z.object({
		chartsHidden: z.boolean().optional().catch(false),
		isActivityStreamClosed: z.boolean().optional().catch(false),
		activityStreamTab: z.enum(ActivityStreamTabName).optional().catch("progress"),
		descriptionExpanded: z.boolean().optional().catch(false),
	}),
};

export type GoalProgressPageState = z.infer<typeof CONFIG.queryParametersSchema>;

export default CONFIG;
